import fetchApi from "../../../../lib/fetchApi";
import { SelectItemDto } from "../../../../types/SelectItemDto";
import { createDictionaryApiFactory, mapDictionaryState } from "./dictionaryApiFactory";

export const mapToAlertDeleteReason = mapDictionaryState;

const alertDeleteReasonApi = createDictionaryApiFactory("alertDeleteReason");

export const getAlertDeleteReason = alertDeleteReasonApi.search;

export const getAlertDeleteReasonSelect = async (): Promise<SelectItemDto[]> => {
    const response = await fetchApi.get(`/alertDeleteReason/select`) as SelectItemDto[];
    return response;
}